
import React, { useCallback } from 'react'
import { validateArray } from '../../../Helper'

export const useValidateCustomOfficesCode=()=> {

     const validateCustomOffices=useCallback((officeList=[])=>{
        officeList=Array.isArray(officeList) ? officeList :[officeList]
        return validateArray(officeList,(item)=>{
            if( ["DEC","EXT"].includes(item.type))
               return {[`header.customsOffice.${item.type}`]:!item.office ? [`OFFICE NAME is mandatory if selected type is ${item.type}`] : ['']}
                
       })
    },[])

    return {validateCustomOffices}
}